<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="从灵感创作" name="1">
        <create-from-inspiration></create-from-inspiration>
      </el-tab-pane>
      <el-tab-pane label="优化现有脚本" name="2">
        <optimize-script></optimize-script>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CreateFromInspiration from './components/create-from-inspiration.vue'
import OptimizeScript from './components/optimize-script.vue'
const activeName = ref('1')
</script>

<style scoped></style>
